module.exports = __webpack_public_path__ + "img/5.aa90334.png";